import { Component, EventEmitter, Inject, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DisplayService } from '@wb/core/services/display.service';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.sass'],
})
export class DialogComponent implements OnInit {
  @Input() backButton?: boolean;

  @Input() banner?: TemplateRef<any> | null = null;

  @Input() cancel?: string;

  @Input() confirmation?: string;

  @Input() counter?: number;

  @Input() hideFooter = false;

  @Input() id?: string;

  @Input() isSaving?: boolean;

  @Input() isValid = true;

  @Input() maxWidth: string = '500px';

  @Input() title?: string;

  @Output() save: EventEmitter<void> = new EventEmitter();

  @Output() back: EventEmitter<void> = new EventEmitter();

  isLoadingData = false;

  constructor(public readonly displayService: DisplayService, @Inject(MAT_DIALOG_DATA) public data?: any) {}

  ngOnInit() {
    if (this.data && this.data.maxWidth) {
      this.maxWidth = this.data.maxWidth;
    }
  }

  onSubmit() {
    // By default we lock the dialog to submit once, If more than one submission is possible set (isSaving) to a component variable where app-dialog is being called.
    if (typeof this.isSaving === 'undefined') {
      this.isSaving = true;
    }
    this.save.next();
  }
}
